export default "__VITE_ASSET__BW0bEf1E__"